import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import auth from './modules/auth.js'
import delegations from './modules/delegations.js'
import lookups from './modules/lookups.js'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        delegations,
        lookups
    },
    plugins: [createPersistedState()]
});